import { useEffect, useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { Link } from 'components/Link/Link'
import { useTabs } from 'hooks'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import moment from 'moment'
import { UseSearchByContract } from 'pages/GST/PesquisaPorContrato/context'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { Iitems } from 'services/GST/PesquisaPorContrato'
import { FORMAT } from 'utils'

interface NewTabProps {
  tabName: string
  createAndNavigateToNewTab?: boolean
  // idContrato: string
}

interface ITableProps {
  tableData: IPaginatedEntityGST<Iitems[]>
  page: number
  rowsPerPage: number
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
  handleChangePage: IHandleChangePage
  areDatesValid: () => boolean
}

export const TableContracts: React.FC<ITableProps> = ({
  tableData,
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  handleChangePage,
  areDatesValid
}) => {
  const { handleAddTab, tabs, handleRemoveTab, rawTabs } = useTabs()
  const [selectedCdContrato, setSelectedCdContrato] = useState<string>('')

  const { handleIdContratoSelecionado } = UseSearchByContract()

  // Controle da abertura da nova tab de visualização do contrato
  const handleNewTab = (tabProps: NewTabProps) => {
    if (tabs.length > 1) {
      handleRemoveTab({
        removeAndNavigateToPreviousDefaultTab: false,
        tabName: rawTabs[1].name
      })
      setSelectedCdContrato(tabProps.tabName)
    } else {
      handleAddTab(tabProps)
    }
  }

  useEffect(() => {
    if (selectedCdContrato) {
      handleNewTab({
        createAndNavigateToNewTab: true,
        tabName: selectedCdContrato
      })
    }
  }, [tabs])

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="20px">Contrato</TableCellStyled>
              <TableCellStyled minwidth="20px">
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled minwidth="30px">Fornecedor</TableCellStyled>
              <TableCellStyled minwidth="30px">Contraparte CSN</TableCellStyled>
              <TableCellStyled minwidth="20px">Empresa</TableCellStyled>
              <TableCellStyled minwidth="20px" align='center'>Centro</TableCellStyled>
              <TableCellStyled minwidth="40px" align="center">
                Data Cadastro
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.entity?.items?.length > 0 &&
              tableData?.entity?.items?.map((row, index) => (
                <TableRowStyled key={`${index}-${row?.cdContrato}`}>
                  <TableCellStyled align="center">
                    <Link
                      color="#3094EE"
                      onClick={() => {
                        handleIdContratoSelecionado(row?.idContratoExternal) // set no Provider
                        handleNewTab({
                          createAndNavigateToNewTab: true,
                          tabName: row?.cdContrato
                        })
                      }}
                    >
                      {row?.cdContrato}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled>
                    {FORMAT.documento(row?.cdDocto) || '---'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.nmFornecedor || '---'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.nmContraparte || '---'}
                  </TableCellStyled>
                  <TableCellStyled>{row?.nmEmpresa || '---'}</TableCellStyled>
                  <TableCellStyled>{row?.nmCentro || '---'}</TableCellStyled>
                  <TableCellStyled align="center">
                    {moment(row?.dtCadastro).format('DD/MM/YYYY')}
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData?.entity?.items}
        totalItems={tableData?.entity?.pageCount}
        rowsPerPage={rowsPerPage}
        disabled={!areDatesValid()}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
